import React from 'react';
import SelectionLivePreview from './SelectionLivePreview';
import C from '../colors';

export default function OrderPreviewPanel({ showImageName, forceLimit, isOnlinePayment, price, photoCount, hasPackage }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ width: 'min(100%, 390px)', margin: '0 auto', padding: '0 0 20px', position: 'sticky', top: 72 }}>
        <div style={{
          padding: 5, borderRadius: 29,
          background: 'linear-gradient(145deg, rgba(255,122,162,.30), rgba(255,238,221,.72))',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,.75)',
        }}>
          <SelectionLivePreview
            showImageName={showImageName}
            forceLimit={forceLimit}
            isOnlinePayment={isOnlinePayment}
            price={price}
            photoCount={photoCount}
            hasPackage={hasPackage}
          />
        </div>
      </div>
    </div>
  );
}
